import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useContextSelector as useCS } from 'use-context-selector';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';

export const useDeleteJobPostById = (): any => {
  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, isLoading, send } = useRequest({
    method: ApiMethodsEnum.Delete,
    sendOnStart: false,
  });

  const deleteJobPostById = (jobPostId, successFunction) => {
    send({}, `/api/v1/jobPosts/${jobPostId}`).then(() => {
      if (update) update({ isOpenDeleteJobPostModal: false, jobPostIdToDelete: null });
      successFunction();
    });
  };

  return {
    isLoading,
    deleteJobPostById,
    data,
  };
};
